module.exports = __webpack_public_path__ + "static/assets/24f7b5d5f544608ccfc1d873f996ad8d.svg";